import { IFinancialAssets } from "./interfaces";
import dayjs from "dayjs";

export function SaveFinancialAssets(this: IFinancialAssets) {
  return {
    entityId: this.entityId,
    entityType: this.entityType,
    nameOrType: this.comment,
    estimatedValue: this.estimatedValue,
    valuationAmount: this.valuationAmount,
    valuationDate:
      this.valuationDate && dayjs(this.valuationDate).isValid()
        ? dayjs(this.valuationDate).format("YYYY-MM-DD")
        : null,
    financialInstitutionName: this.financialInstitutionName,
    financialInstitutionAddress1: this.financialInstitutionAddress1,
    financialInstitutionAddress2: this.financialInstitutionAddress2,
    nin: this.nin,
    financialInstitutionPostalCode: this.financialInstitutionPostalCode,
    financialInstitutionMunicipalityCode: this.financialInstitutionMunicipalityCode,
    description: this.description,
  };
}
